import { BaseEntity } from "@planard/@core/base/BaseEntity";

export class Price extends BaseEntity {
  rows?: any[];
}
